import React, { useState } from "react";
import { Input } from "../../atom/Input";
import { Button } from "../../atom/Button";
import { useTranslation } from "react-i18next";
import { validateEmail } from "../../../utils/validations";
import { ArrowRight } from "@carbon/icons-react";
import { successToast } from "../../../utils/toast";
import { requestPasswordReset } from "../../../services/apiHelpers";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { t } = useTranslation();

  const onEmailBlur = () => {
    if (!validateEmail(email)) {
      setErrorMessage(t("Invalid email format"));
    } else {
      setErrorMessage("");
    }
  };

  const handleConfirm = async () => {
    if (errorMessage) {
      return;
    }

    const success = await requestPasswordReset(email);

    if (!success) {
      return;
    }

    successToast(t("Password reset email has been sent"));
  };

  return (
    <div className="flex items-center justify-center bg-white">
      <div className="flex flex-col justify-center items-center min-w-[360px] max-w-[360px] mt-24 gap-8">
        <div className="flex flex-col justify-center items-center gap-[120px]">
          <img src="/images/logo.svg" className="h-[24px]" alt="" />
          <div className="flex flex-col justify-center items-center gap-3">
            <p className="font-semibold text-[32px] leading-[40.32px] tracking-[-0.1px] text-black">
              {t("Forgot Password")}
            </p>
            <p className="font-light text-[16px] leading-[22.4px] tracking-[0.2px] text-gray-550">
              {t("Enter your email to reset your password")}
            </p>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center w-full gap-6">
          <div className="w-full">
            <Input
              id="email"
              type="email"
              value={email}
              placeholder={t("Enter your email")}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={onEmailBlur}
            />
            {errorMessage && (
              <p className="text-red-500 font-normal text-[14px] leading-[19.6px] tracking-[0px] mt-1">
                {errorMessage}
              </p>
            )}
          </div>
          <div className="w-full">
            <Button
              type="primary"
              label={t("Reset Password")}
              leftIcon={<ArrowRight size={20} />}
              additionalClassName="flex items-center justify-center w-full"
              onClick={handleConfirm}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
